module.exports = __webpack_public_path__ + "img/13@2x.3db1c6d7.png";